import { SocketEvent } from '@debbie/common/dist/web-sockets';
import { Direction, IncomingState, OutgoingState, } from '@debbie/common/dist/interactions';
import * as interactionsAPI from '../api/interactions';
import { fetchLoadable } from '../fetchLoadable';
import { dispatch } from '../internal';
import { subscribeToEvent } from '../socket';
import store from '../store';
import { FETCH_OUTGOING, FETCH_INCOMING, SET_OUTGOING_FILTER, } from './actionTypes';
import q from '../query';
import { interactionsByReferenceKey } from '.';
export const getOutgoingInteractions = () => fetchLoadable(FETCH_OUTGOING, () => interactionsAPI.getMultiple({
    state: OutgoingState.PENDING,
    direction: Direction.OUTGOING,
}, {
    paused: true,
}));
export const getIncomingInteractions = () => fetchLoadable(FETCH_INCOMING, () => interactionsAPI.getMultiple({
    state: IncomingState.UNMAPPED,
    direction: Direction.INCOMING,
}));
export const setOutgoingFilter = (filter) => dispatch({ type: SET_OUTGOING_FILTER, payload: filter });
const newInteractions = (newInteractions) => {
    const s = store.getState();
    for (let i = 0; i < newInteractions.length; i++) {
        const interaction = newInteractions[i];
        if (interaction.referenceType && interaction.referenceId) {
            q.mutateCache(interactionsByReferenceKey(interaction.referenceType, interaction.referenceId), (interactions) => {
                if (!interactions) {
                    return interactions;
                }
                const n = [interaction, ...interactions];
                return n.filter((interaction, index) => n.indexOf(interaction) === index);
            });
        }
    }
};
subscribeToEvent(SocketEvent.NEWINTERACTIONS, newInteractions);
//# sourceMappingURL=actions.js.map